import { useMutation } from '@apollo/client'

import {
  CreateCustomerPortalLinkDocument,
  CreateStripeProductLinkDocument,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`
  mutation CreateCustomerPortalLink {
    createCustomerPortalLink
  }
`

export const useCustomerPortalLink = () => {
  const [mutate, { loading }] = useMutation(CreateCustomerPortalLinkDocument, {
    client: atlasClient,
  })

  function createCustomerPortalLink() {
    return mutate()
  }

  return {
    createCustomerPortalLink,
    loading,
  }
}

atlas`
  mutation CreateStripeProductLink($priceId: String!, $returnUrl: String) {
    createStripeProductLink(priceId: $priceId, returnUrl: $returnUrl)
  }
`

export const useCreateStripeProductLink = () => {
  const [mutate, { loading }] = useMutation(CreateStripeProductLinkDocument, {
    client: atlasClient,
  })

  function createStripeProductLink(priceId?: string) {
    if (!priceId) {
      throw new Error(
        'createStripeProductLink can only be called with a price id',
      )
    }

    return mutate({
      variables: { priceId: priceId, returnUrl: window.location.href },
    })
  }

  return { createStripeProductLink, loading }
}
